import { track } from "../tracker/EventTracker";

class FAQEntry extends HTMLElement {
	connectedCallback() {
		const toggleClass = this.getAttribute("toggle");
		this.querySelector("[data-button]").addEventListener("click", () => {
			this.classList.toggle(toggleClass);
			track(
				"FAQ",
				this.classList.contains(toggleClass)
					? "Klick öffnen"
					: "Klick schließen",
				this.getAttribute("event-action"),
			);
		});
	}
}

customElements.define("esc-faq-entry", FAQEntry);
